/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import {
  endpoints,
  type QueryElementInstancesRequestBody,
  type QueryElementInstancesResponseBody,
} from '@camunda/camunda-api-zod-schemas/8.10';
import {requestWithThrow} from 'modules/request';

const searchElementInstances = async (
  payload: QueryElementInstancesRequestBody,
  signal?: AbortSignal,
) => {
  return requestWithThrow<QueryElementInstancesResponseBody>({
    url: endpoints.queryElementInstances.getUrl(),
    method: endpoints.queryElementInstances.method,
    body: payload,
    signal,
  });
};

export {searchElementInstances};
